import type { ReactElement } from 'react'

import BlockItem from '../BlockItem'

import MwMLoader from '~/components/MwMLoader'
import { dataNotAvailableText } from '~/const'
import { useAppSummary } from '~/providers/AppSummary'
import { useVersionsListQueryV2 } from '~/queries/versions'
import { getExternalStoreId } from '~/utils/application'

const VersionsBlock = (): ReactElement => {
  const { appDetails, deviceType } = useAppSummary()

  const { data: versionsData, isLoading } = useVersionsListQueryV2({
    deviceType,
    externalId: appDetails ? getExternalStoreId(appDetails, deviceType) : undefined,
    limit: 3,
  })

  if (isLoading) {
    return <MwMLoader category="item" />
  }

  if (!versionsData?.total) {
    return <span>{dataNotAvailableText}</span>
  }

  return (
    <>
      {versionsData?.data?.map(({ release_date, semantic_version }, idx) => (
        <BlockItem date={release_date} key={idx} title={semantic_version} />
      ))}
    </>
  )
}

export default VersionsBlock
